/* Product page — a variant picker that knows nothing about what it is selling.
 *
 * Contract:
 *   - options are matched by value against variant.options, never by array
 *     position guessing or by option name, so renaming or reordering options
 *     in Shopify cannot silently break the picker
 *   - works with one, two or three options, in any combination
 *   - a combination that has no variant at all is disabled; a combination that
 *     exists but is out of stock stays selectable and struck through, so the
 *     customer can always see what is gone and never gets stuck in a dead end
 *   - init is idempotent: Theme Editor section reloads re-bind cleanly
 *   - the page is fully usable with this file blocked (see the <noscript> form)
 */
(function () {
  'use strict';

  var BOUND = 'chBound';

  function parseData(root) {
    var tag = root.querySelector('[data-product-data]');
    if (!tag) return null;
    try { return JSON.parse(tag.textContent); }
    catch (e) { return null; }
  }

  function init(root) {
    if (!root || root.dataset[BOUND]) return;
    var data = parseData(root);
    if (!data || !data.variants || !data.variants.length) return;
    root.dataset[BOUND] = '1';

    var form = root.querySelector('#pdp-form') || root.querySelector('form[action*="/cart/add"]');
    var idInput = root.querySelector('[data-variant-id-input]');
    var submit = root.querySelector('[data-submit]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var saveEl = root.querySelector('[data-save]');
    var stockEl = root.querySelector('[data-stock]');
    var summaryEl = root.querySelector('[data-selection-summary]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var stickyCta = root.querySelector('[data-sticky-cta]');
    var optionSets = Array.prototype.slice.call(root.querySelectorAll('[data-option-set]'));
    var labels = data.optionLabels || {};
    function labelFor(v) { return v == null ? '' : (labels[v] || v); }
    var qtyInput = root.querySelector('[data-qty]');
    var formError = root.querySelector('[data-form-error]');
    var addon = data.upsell && data.upsell.variants && data.upsell.variants.length ? data.upsell : null;
    var addonRoot = root.querySelector('[data-addon]');
    var addonSel = root.querySelector('[data-addon-color]');
    var addonCheck = root.querySelector('[data-addon-optin]');
    var addonPrice = root.querySelector('[data-addon-price]');
    var addonImg = addonRoot ? addonRoot.querySelector('.addon-media img') : null;
    var addonNote = root.querySelector('[data-addon-note]');
    var mainImage = root.querySelector('[data-main-image]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.pdp-thumb'));

    var radios = Array.prototype.slice.call(root.querySelectorAll('[data-option-input]'));
    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-option-select]'));
    var optionCount = data.optionNames ? data.optionNames.length : 0;

    var mediaById = {};
    (data.media || []).forEach(function (m) { mediaById[m.id] = m; });

    /* ---------------- current selection, by option position ---------------- */
    function readSelection() {
      var values = new Array(optionCount);
      radios.forEach(function (r) {
        if (r.checked) values[Number(r.dataset.optionPosition) - 1] = r.value;
      });
      selects.forEach(function (sel) {
        values[Number(sel.dataset.optionPosition) - 1] = sel.value === '' ? undefined : sel.value;
      });
      return values;
    }

    function findVariant(values) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        var hit = true;
        for (var j = 0; j < values.length; j++) {
          if (values[j] !== undefined && v.options[j] !== values[j]) { hit = false; break; }
        }
        if (hit) return v;
      }
      return null;
    }

    /* Does any variant exist with `value` at `index`, holding every other
       currently-selected option fixed? */
    function comboExists(index, value, values) {
      return data.variants.some(function (v) {
        if (v.options[index] !== value) return false;
        for (var j = 0; j < values.length; j++) {
          if (j !== index && values[j] !== undefined && v.options[j] !== values[j]) return false;
        }
        return true;
      });
    }

    function comboAvailable(index, value, values) {
      return data.variants.some(function (v) {
        if (v.options[index] !== value || !v.available) return false;
        for (var j = 0; j < values.length; j++) {
          if (j !== index && values[j] !== undefined && v.options[j] !== values[j]) return false;
        }
        return true;
      });
    }

    /* ---------------- painting ---------------- */
    function setMedia(mediaId) {
      if (!mainImage || mediaId == null) return;
      var m = mediaById[mediaId];
      if (!m || mainImage.dataset.currentMedia === String(mediaId)) return;

      mainImage.dataset.currentMedia = String(mediaId);
      mainImage.src = m.src;
      mainImage.srcset = m.srcset;
      if (m.width) mainImage.width = m.width;
      if (m.height) mainImage.height = m.height;
      mainImage.alt = m.alt || data.productTitle || '';

      thumbs.forEach(function (t) {
        var on = t.dataset.mediaId === String(mediaId);
        if (on) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
        /* A variant photo hidden behind "All photos" is revealed rather than
           silently missing from the strip. */
        if (on) {
          var li = t.closest('[data-thumb-item]');
          if (li && li.hidden) li.hidden = false;
        }
      });
    }

    function setText(el, text) { if (el) el.textContent = text; }

    function setSticky(text, mode) {
      if (!stickyCta) return;
      stickyCta.textContent = text;
      stickyCta.disabled = mode === 'disabled';
      if (mode === 'submit') {
        stickyCta.type = 'submit';
        stickyCta.setAttribute('form', 'pdp-form');
        stickyCta.removeAttribute('data-sticky-choose');
      } else {
        stickyCta.type = 'button';
        stickyCta.removeAttribute('form');
        if (mode === 'choose') stickyCta.setAttribute('data-sticky-choose', '');
        else stickyCta.removeAttribute('data-sticky-choose');
      }
    }

    function paint(variant, values, complete) {
      /* option labels, shown through their display names */
      values.forEach(function (val, i) {
        var label = root.querySelector('[data-option-current="' + (i + 1) + '"]');
        if (label) label.textContent = labelFor(val);
      });

      /* "6-Piece Set — Blue", in the order the pickers appear on the page */
      if (summaryEl) {
        var parts = [];
        optionSets.forEach(function (set) {
          var idx = Number(set.dataset.optionPosition) - 1;
          if (values[idx] !== undefined) parts.push(labelFor(values[idx]));
        });
        summaryEl.textContent = parts.join(' \u2014 ');
      }

      /* availability of every value, given the rest of the selection */
      radios.forEach(function (r) {
        var index = Number(r.dataset.optionPosition) - 1;
        var exists = comboExists(index, r.value, values);
        r.disabled = !exists;
        if (exists && !comboAvailable(index, r.value, values)) r.setAttribute('data-soldout', 'true');
        else r.removeAttribute('data-soldout');
      });
      selects.forEach(function (sel) {
        var index = Number(sel.dataset.optionPosition) - 1;
        Array.prototype.forEach.call(sel.options, function (opt) {
          if (!opt.dataset.baseLabel) opt.dataset.baseLabel = opt.textContent;
          var exists = comboExists(index, opt.value, values);
          var avail = exists && comboAvailable(index, opt.value, values);
          opt.disabled = !exists || !avail;
          opt.textContent = exists && !avail
            ? opt.dataset.baseLabel + ' — ' + data.strings.soldOut
            : opt.dataset.baseLabel;
        });
      });

      if (!complete) {
        /* Not every option chosen yet: keep price/photo/stock of the variant
           shown on load, arm nothing, and let the sticky bar scroll to the
           pickers. */
        if (idInput) idInput.value = '';
        if (submit) { submit.disabled = true; submit.textContent = data.strings.chooseOptions; }
        setSticky(data.strings.chooseOptions, 'choose');
        return;
      }

      if (!variant) {
        if (idInput) idInput.value = '';
        if (submit) { submit.disabled = true; submit.textContent = data.strings.unavailable; }
        setText(stockEl, data.strings.unavailable);
        if (stockEl) stockEl.classList.add('is-out');
        setSticky(data.strings.unavailable, 'disabled');
        return;
      }

      if (idInput) idInput.value = variant.id;
      setText(priceEl, variant.priceFormatted);
      setText(stickyPrice, variant.priceFormatted);

      var onSale = variant.compareAtPrice && variant.compareAtPrice > variant.price;
      if (compareEl) {
        if (onSale) {
          compareEl.textContent = variant.compareAtFormatted;
          compareEl.hidden = false;
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
      }
      if (saveEl) {
        if (onSale && data.strings.savePercent) {
          var pct = Math.round((variant.compareAtPrice - variant.price) / variant.compareAtPrice * 100);
          saveEl.textContent = data.strings.savePercent.replace('__PCT__', pct);
          saveEl.hidden = false;
        } else {
          saveEl.textContent = '';
          saveEl.hidden = true;
        }
      }

      setText(stockEl, variant.available ? data.strings.inStock : data.strings.soldOut);
      if (stockEl) stockEl.classList.toggle('is-out', !variant.available);

      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? data.strings.addToCart : data.strings.soldOut;
      }
      setSticky(variant.available ? data.strings.addToCart : data.strings.soldOut,
                variant.available ? 'submit' : 'disabled');

      setMedia(variant.featuredMediaId);

      /* Keep the address bar honest so a shared link opens the same variant.
         replaceState, not pushState: choosing an option is not a page the
         customer should have to press Back through. */
      if (window.history && window.history.replaceState && data.productUrl) {
        window.history.replaceState({}, '', data.productUrl + '?variant=' + variant.id);
      }
    }

    /* ---------------- optional add-on card ----------------
       The add-on is whatever product the merchant picked in the theme editor;
       nothing here knows which product it is. Its colour option is found by
       NAME, its price and photo come from the chosen variant, and a colour
       that is sold out stays visible but cannot be chosen. */
    function optionIndex(names, test) {
      for (var i = 0; i < names.length; i++) if (test(String(names[i]).toLowerCase())) return i;
      return -1;
    }
    var addonColourIdx = addon ? optionIndex(addon.optionNames || [], function (n) { return /colou?r|shade|finish/.test(n); }) : -1;
    var addonReady = !!(addon && addonRoot && addonSel && addonCheck && addonColourIdx > -1);
    if (addonRoot && !addonReady) {
      addonRoot.hidden = true;
      if (window.console) console.warn('[CURATED.] add-on card hidden: add-on data has no colour option or no variants.');
    }
    var addonMediaById = {};
    if (addon && addon.media) addon.media.forEach(function (m) { addonMediaById[m.id] = m; });
    var addonVariant = null;

    /* Shop money format ("${{amount}}", "{{amount_with_comma_separator}} €" …). */
    function formatMoney(cents) {
      var fmt = data.moneyFormat || '${{amount}}';
      var n = Number(cents) / 100;
      function group(str) { return str.replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
      var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
        switch (key) {
          case 'amount_no_decimals': return group(Math.round(n).toString());
          case 'amount_with_comma_separator': { var parts = n.toFixed(2).split('.'); return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1]; }
          case 'amount_no_decimals_with_comma_separator': return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          default: { var p2 = n.toFixed(2).split('.'); return group(p2[0]) + '.' + p2[1]; }
        }
      });
      return out.replace(/<[^>]+>/g, '');
    }
    var addonPriceWas = root.querySelector('[data-addon-price-was]');
    var addonPriceTag = root.querySelector('[data-addon-price-tag]');
    var addonDiscount = data.addonDiscount && data.addonDiscount.verified && Number(data.addonDiscount.cents) > 0 ? Number(data.addonDiscount.cents) : 0;

    function setAddonNote(t) { if (addonNote && addonNote.textContent !== t) addonNote.textContent = t; }
    function addonVariantFor(colour) {
      for (var i = 0; i < addon.variants.length; i++) {
        if (addon.variants[i].options[addonColourIdx] === colour) return addon.variants[i];
      }
      return null;
    }
    function paintAddonOptions() {
      Array.prototype.forEach.call(addonSel.options, function (opt) {
        if (!opt.value) return;
        if (!opt.dataset.baseLabel) opt.dataset.baseLabel = opt.textContent;
        var v = addonVariantFor(opt.value);
        var avail = !!(v && v.available);
        opt.disabled = !avail;
        opt.textContent = avail ? opt.dataset.baseLabel : opt.dataset.baseLabel + ' \u2014 ' + data.strings.soldOut;
      });
    }
    function setAddonImage(colour) {
      if (!addonImg) return;
      var m = addonVariant && addonVariant.featuredMediaId != null ? addonMediaById[addonVariant.featuredMediaId] : null;
      var src = m || addon.fallbackMedia;
      if (src && addonImg.dataset.currentMedia !== String(src.id)) {
        addonImg.src = src.src;
        addonImg.srcset = src.srcset;
        if (src.width) addonImg.width = src.width;
        if (src.height) addonImg.height = src.height;
        addonImg.dataset.currentMedia = String(src.id);
      }
      addonImg.alt = colour ? addon.title + ' in ' + colour : addon.title;
    }
    function paintAddon() {
      var colour = addonSel.value;
      addonVariant = colour ? addonVariantFor(colour) : null;
      var ok = !!(addonVariant && addonVariant.available);
      if (addonVariant) {
        if (addonDiscount > 0 && addonVariant.price > addonDiscount) {
          setText(addonPrice, formatMoney(addonVariant.price - addonDiscount));
          if (addonPriceWas) { addonPriceWas.textContent = addonVariant.priceFormatted; addonPriceWas.hidden = false; }
          if (addonPriceTag) addonPriceTag.hidden = false;
        } else {
          setText(addonPrice, addonVariant.priceFormatted);
          if (addonPriceWas) addonPriceWas.hidden = true;
          if (addonPriceTag) addonPriceTag.hidden = true;
        }
      }
      setAddonImage(colour);
      addonCheck.disabled = !ok;
      if (!ok) addonCheck.checked = false;
      var price = addonVariant ? (addonDiscount > 0 && addonVariant.price > addonDiscount ? formatMoney(addonVariant.price - addonDiscount) : addonVariant.priceFormatted) : '';
      if (!colour) setAddonNote(data.strings.addonPickColor);
      else if (!ok) setAddonNote(data.strings.addonUnavailable.replace('__COLOR__', colour));
      else if (addonCheck.checked) setAddonNote(data.strings.addonWillAdd.replace('__COLOR__', colour).replace('__PRICE__', price));
      else setAddonNote(data.strings.addonReady.replace('__COLOR__', colour).replace('__PRICE__', price));
      addonRoot.classList.toggle('is-on', ok && addonCheck.checked);
    }
    if (addonReady) {
      paintAddonOptions();
      paintAddon();
      addonSel.addEventListener('change', paintAddon);
      addonCheck.addEventListener('change', paintAddon);
    }

    /* Adding both lines in ONE cart/add.js request. Only runs when the add-on
       is opted in with a valid colour; otherwise the form posts natively. */
    var submitting = false;
    function showError(msg) {
      if (!formError) return;
      formError.textContent = msg || data.strings.addError;
      formError.hidden = false;
    }
    function setBusy(busy) {
      [submit, stickyCta].forEach(function (b) {
        if (!b) return;
        if (busy) { b.textContent = data.strings.adding; b.disabled = true; }
      });
      if (!busy) sync();
    }
    if (form && addonReady) {
      form.addEventListener('submit', function (e) {
        if (!addonCheck.checked || !addonVariant || !addonVariant.available) return;
        e.preventDefault();
        if (submitting) return;
        var mainId = idInput && idInput.value;
        if (!mainId) return;
        submitting = true;
        if (formError) formError.hidden = true;
        var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
        var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        setBusy(true);
        fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [
            { id: Number(mainId), quantity: qty },
            { id: Number(addonVariant.id), quantity: 1 }
          ] })
        }).then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (body) { return { ok: r.ok, body: body }; });
        }).then(function (res) {
          if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || data.strings.addError);
          /* Same destination as the native form: the cart page. */
          window.location.href = rootPath + 'cart';
        }).catch(function (err) {
          submitting = false;
          setBusy(false);
          showError(err && err.message ? err.message : data.strings.addError);
        });
      });
    }

    /* ---------------- "Buy 2, get 1 free" bundle ----------------
       Three colour pickers over this product's own variants; one request adds
       all three with identical variants merged into one line. Totals only
       claim a free item once the merchant has ticked "discount verified". */
    var bundle = data.bundle;
    var bundleRoot = root.querySelector('[data-bundle]');
    var bundleSlots = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-slot]'));
    var bundleTotals = root.querySelector('[data-bundle-totals]');
    var bundleReady = !!(bundle && bundleRoot && bundleSlots.length === 3 && bundle.colourIndex >= 0);
    var bundleItems = null;

    function bundleVariantFor(colour) {
      for (var i = 0; i < data.variants.length; i++) if (data.variants[i].options[bundle.colourIndex] === colour) return data.variants[i];
      return null;
    }
    function paintBundleOptions() {
      bundleSlots.forEach(function (sel) {
        Array.prototype.forEach.call(sel.options, function (opt) {
          if (!opt.value) return;
          if (!opt.dataset.baseLabel) opt.dataset.baseLabel = opt.textContent;
          var v = bundleVariantFor(opt.value);
          var avail = !!(v && v.available);
          opt.disabled = !avail;
          opt.textContent = avail ? opt.dataset.baseLabel : opt.dataset.baseLabel + ' \u2014 ' + data.strings.soldOut;
        });
      });
    }
    function paintBundle() {
      var chosen = bundleSlots.map(function (sel) { return sel.value ? bundleVariantFor(sel.value) : null; });
      var complete = chosen.every(function (v) { return v && v.available; });
      bundleItems = null;
      if (complete) {
        var merged = {};
        chosen.forEach(function (v) { merged[v.id] = (merged[v.id] || 0) + 1; });
        bundleItems = Object.keys(merged).map(function (id) { return { id: Number(id), quantity: merged[id] }; });
        var regular = chosen.reduce(function (sum, v) { return sum + v.price; }, 0);
        var free = chosen.slice().sort(function (a, b) { return a.price - b.price; })[0].price;
        var total = bundle.verified ? regular - free : regular;
        var totalFmt = formatMoney(total);
        if (bundleTotals) bundleTotals.textContent = bundle.verified
          ? data.strings.bundleTotalsVerified.replace('__REGULAR__', formatMoney(regular)).replace('__TOTAL__', totalFmt)
          : data.strings.bundleTotalsPlain.replace('__EACH__', chosen[0].priceFormatted).replace('__TOTAL__', totalFmt);
        if (submit) { submit.disabled = false; submit.textContent = data.strings.bundleCta.replace('__TOTAL__', totalFmt); }
        setText(stickyPrice, totalFmt);
        setSticky(data.strings.addToCart, 'submit');
        setText(stockEl, data.strings.inStock); if (stockEl) stockEl.classList.remove('is-out');
      } else {
        if (bundleTotals) bundleTotals.textContent = '';
        if (submit) { submit.disabled = true; submit.textContent = data.strings.bundleChoose; }
        setSticky(data.strings.bundleChoose, 'choose');
      }
      var firstChosen = chosen.find(function (v) { return v; });
      if (firstChosen) setMedia(firstChosen.featuredMediaId);
    }
    if (bundleReady) {
      paintBundleOptions();
      bundleSlots.forEach(function (sel) { sel.addEventListener('change', paintBundle); });
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (submitting || !bundleItems) return;
          submitting = true;
          if (formError) formError.hidden = true;
          var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          setBusy(true);
          fetch(rootPath + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: bundleItems })
          }).then(function (r) {
            return r.json().catch(function () { return {}; }).then(function (body) { return { ok: r.ok, body: body }; });
          }).then(function (res) {
            if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || data.strings.addError);
            window.location.href = rootPath + 'cart';
          }).catch(function (err) {
            submitting = false;
            setBusy(false);
            showError(err && err.message ? err.message : data.strings.addError);
          });
        });
      }
    }

    function sync() {
      if (bundleReady) { paintBundle(); return; }
      var values = readSelection();
      var complete = true;
      for (var i = 0; i < optionCount; i++) if (values[i] === undefined) complete = false;
      paint(complete ? findVariant(values) : null, values, complete);
    }

    /* Sticky "Choose options": glide to the first picker. */
    if (stickyCta) {
      stickyCta.addEventListener('click', function (e) {
        if (!stickyCta.hasAttribute('data-sticky-choose')) return;
        e.preventDefault();
        var first = (bundleReady ? bundleSlots[0].closest('.opt-set') : optionSets[0]) || form;
        if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var firstSelect = first && first.querySelector('select, input');
        if (firstSelect) setTimeout(function () { firstSelect.focus({ preventScroll: true }); }, 450);
      });
    }

    radios.forEach(function (r) { r.addEventListener('change', sync); });
    selects.forEach(function (s) { s.addEventListener('change', sync); });

    /* ---------------- gallery ---------------- */
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { setMedia(Number(t.dataset.mediaId)); });
    });

    /* "View all N photos" is a persistent toggle: it reveals the overflow
       thumbnails, then folds them back. It never touches the main image, the
       variant selection or the cart, and focus stays on the button. */
    var moreBtn = root.querySelector('[data-thumbs-more]');
    if (moreBtn) {
      var moreLabel = moreBtn.querySelector('[data-thumbs-more-label]');
      var iconExpand = moreBtn.querySelector('[data-thumbs-more-icon="expand"]');
      var iconCollapse = moreBtn.querySelector('[data-thumbs-more-icon="collapse"]');
      function setThumbsExpanded(expanded) {
        root.querySelectorAll('[data-overflow]').forEach(function (li) { li.hidden = !expanded; });
        moreBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        var label = expanded ? moreBtn.dataset.labelLess : moreBtn.dataset.labelMore;
        if (moreLabel && label) moreLabel.textContent = label;
        if (iconExpand) iconExpand.hidden = expanded;
        if (iconCollapse) iconCollapse.hidden = !expanded;
      }
      moreBtn.addEventListener('click', function () {
        setThumbsExpanded(moreBtn.getAttribute('aria-expanded') !== 'true');
      });
    }

    /* ---------------- zoom ---------------- */
    var zoom = root.querySelector('[data-zoom]');
    var zoomImg = root.querySelector('[data-zoom-image]');
    var zoomOpen = root.querySelector('[data-zoom-open]');
    var zoomClose = root.querySelector('[data-zoom-close]');

    if (zoom && zoomImg && zoomOpen && zoomClose) {
      var lastFocus = null;

      var closeZoom = function () {
        zoom.classList.remove('is-open');
        zoom.hidden = true;
        document.documentElement.style.overflow = '';
        if (lastFocus) lastFocus.focus();
      };

      zoomOpen.addEventListener('click', function () {
        if (!mainImage) return;
        lastFocus = document.activeElement;
        zoomImg.src = mainImage.currentSrc || mainImage.src;
        zoomImg.alt = mainImage.alt;
        zoom.hidden = false;
        /* next frame, so the transition has a start state to run from */
        window.requestAnimationFrame(function () { zoom.classList.add('is-open'); });
        document.documentElement.style.overflow = 'hidden';
        zoomClose.focus();
      });

      zoomClose.addEventListener('click', closeZoom);
      zoom.addEventListener('click', function (e) { if (e.target === zoom) closeZoom(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && zoom.classList.contains('is-open')) closeZoom();
      });
    }

    /* ---------------- quantity ---------------- */
    var qty = root.querySelector('[data-qty]');
    var down = root.querySelector('[data-qty-down]');
    var up = root.querySelector('[data-qty-up]');
    if (qty && down && up) {
      var step = function (delta) {
        var next = Math.max(1, (parseInt(qty.value, 10) || 1) + delta);
        qty.value = next;
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      };
      down.addEventListener('click', function () { step(-1); });
      up.addEventListener('click', function () { step(1); });
      qty.addEventListener('blur', function () {
        if (!qty.value || parseInt(qty.value, 10) < 1) qty.value = 1;
      });
    }

    /* Paint once on load so a URL like ?variant=123 and the markup agree, and
       so unavailable combinations are marked before the first click. */
    sync();

    if (form) {
      form.addEventListener('submit', function () {
        if (submit && !submit.disabled) submit.textContent = data.strings.addToCart;
      });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-product-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
